/* eslint-disable   */

import axios from "axios";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig, loginApiRequest } from "../authConfig";

const msalInstance = new PublicClientApplication(msalConfig);

const BASE_URL = `${process.env.REACT_APP_API_HOST_URL}/api`;
const token = "";
const APIRequest = async ({
  requestBody = {},
  url,
  queryParams = {},
  method,
}) => {
  const account = msalInstance.getAllAccounts()[0];
  const msalResponse = await msalInstance.acquireTokenSilent({
    ...loginApiRequest,
    // eslint-disable-next-line object-shorthand
    account: account,
  });

  var config = {
    method: `${method}`,
    url: `${BASE_URL + url}`,
    headers: { Authorization: `Bearer ${msalResponse.accessToken}` },
    // withCredentials: true,
    data: requestBody,
  };

  const response = {
    message: "",
    messageAr: "",
    success: false,
    body: {},
  };

  // console.log(`APIRequest :: requestBody: ${JSON.stringify(requestBody)}`);
  // console.log(`APIRequest :: url: ${url}`);
  // console.log(`APIRequest :: queryParams: ${JSON.stringify(queryParams)}`);

  return axios(config)
    .then((res) => {
      // console.log(`APIRequest :: res: ${JSON.stringify(res)}`);
      response.success = true;
      response.message = [res?.data?.description];
      response.messageAr = [res?.data?.descriptionAR];
      response.body = res?.data?.responseBody?.data || res?.data?.data;
      response.pagination = res?.data?.pagination;
    })
    .catch(function (error) {
      // console.log(`error.response: ${JSON.stringify(error)}`);
      // console.log(
      //   `error?.response?.data?.errors.defaultMessage: ${error?.response?.data?.errors?.defaultMessage}`
      // );
      const resMessage = !!error?.response?.data?.errors
        ? error?.response?.data?.errors.map((e) => e?.defaultMessage)
        : [error?.response?.data?.message || error.message || error.toString()];
      // console.log(`APIRequest :: catch :: resMessage:\n ${resMessage}`);
      response.message = resMessage;
      response.success = false;
    })
    .then(function () {
      // console.log(
      //   `APIRequest :: Finally :: response:\n ${JSON.stringify(response)}`
      // );
      return response;
    });
};
const APIRequestForPublic = async ({
  requestBody = {},
  url,
  queryParams = {},
  method,
}) => {
  var config = {
    method: `${method}`,
    url: `${BASE_URL + url}`,
    // withCredentials: true,
    data: requestBody,
  };
  const response = {
    message: "",
    messageAr: "",
    success: false,
    body: {},
  };

  // console.log(`APIRequest :: requestBody: ${JSON.stringify(requestBody)}`);
  // console.log(`APIRequest :: url: ${url}`);
  // console.log(`APIRequest :: queryParams: ${JSON.stringify(queryParams)}`);

  return axios(config)
    .then((res) => {
      // console.log(`APIRequest :: res: ${JSON.stringify(res)}`);
      response.success = true;
      response.message = [res?.data?.description];
      response.messageAr = [res?.data?.descriptionAR];
      response.body = res?.data?.responseBody?.data || res?.data?.data;
      response.pagination = res?.data?.pagination;
    })
    .catch(function (error) {
      // console.log(`error.response: ${JSON.stringify(error)}`);
      // console.log(
      //   `error?.response?.data?.errors.defaultMessage: ${error?.response?.data?.errors?.defaultMessage}`
      // );
      const resMessage = !!error?.response?.data?.errors
        ? error?.response?.data?.errors.map((e) => e?.defaultMessage)
        : [error?.response?.data?.message || error.message || error.toString()];
      // console.log(`APIRequest :: catch :: resMessage:\n ${resMessage}`);
      response.message = resMessage;
      response.success = false;
    })
    .then(function () {
      // console.log(
      //   `APIRequest :: Finally :: response:\n ${JSON.stringify(response)}`
      // );
      return response;
    });
};
export { APIRequest, APIRequestForPublic };
